import { render, staticRenderFns } from "./SelectArea.vue?vue&type=template&id=04a3eb12&scoped=true&"
import script from "./SelectArea.vue?vue&type=script&lang=js&"
export * from "./SelectArea.vue?vue&type=script&lang=js&"
import style0 from "./SelectArea.vue?vue&type=style&index=0&id=04a3eb12&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a3eb12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
